import React, { useState, useEffect } from "react";
import "./Setup.css";
import { useStateValue } from "./StateProvider";
import { db } from "./firebase";
import Player from "./Player";
import { Link } from "react-router-dom";
import "react-widgets/dist/css/react-widgets.css";

function SetUp() {
  const [{ players }, dispatch5] = useStateValue();
  const [{ user }] = useStateValue();
  const [dispatch] = useStateValue();
  const [{ todaysEvent }, saveEvent] = useStateValue();
  const [{ eventDate }] = useStateValue();
  const [{ location }] = useStateValue();
  const [{ atCourse }] = useStateValue();
  const [{ holeDistances }, saveCourseInfo] = useStateValue();
  const [golfers, setGolfers] = useState(
    localStorage.getItem("golfers") == null
      ? []
      : JSON.parse(localStorage.getItem("golfers"))
  );

  useEffect(() => {
    localStorage.setItem("golfers", JSON.stringify(golfers));
  }, [golfers]);

  useEffect(() => {
    localStorage.setItem("players", JSON.stringify(players));
  }, [players]);

  useEffect(() => {
    if (todaysEvent !== "undefined") {
      localStorage.setItem("todaysEvent", JSON.stringify(todaysEvent));
    } else {
      todaysEvent = [];
    }
  }, [todaysEvent]);

  //add logged in user
  // useEffect(() => {
  //   if (user) {
  //       addPlayer(user.uid);
  //   }
  // }, []);

  useEffect(() => {
    const getEventFromFirebase = async () => {
      const ev = await db
        .collection("events")
        .doc(eventDate)
        .get()
        .then((doc) => {
          if (doc.data() != undefined) {
            // console.log("Event", doc.data());
            if (doc.data().fb === "Back") {
              dispatch({
                type: "NEXTHOLE",
                num: { hole: 9 },
              });
            }
            saveEvent({
              type: "ADDEVENT",
              event: doc.data(),
            });
          }
        });
    };
    getEventFromFirebase();
    atCourse && fetchGolfers();
  }, []);

  //get golfers
  const fetchGolfers = async () => {
    const golfersCollection = await db
      .collection("events")
      .doc(eventDate)
      .collection("scores")
      .where("isLocked", "==", false)
      .orderBy("name")
      .get();
    setGolfers(
      golfersCollection.docs.map((doc) => {
        return doc.data();
      })
    );
  };

  const fetchNewGolfers = () => {
    setGolfers([]);
    atCourse && fetchGolfers();
  };

  const addPlayer = (id) => {
    // console.log(parseInt(id))

    const fetchedGolfer = golfers.find((s) => s.idgolfer === parseInt(id));
    const checkPlayers = [players.find((s) => s.idgolfer === parseInt(id))];
    // console.log("Check if golfer already a Player", fetchedGolfer);
    const newList = golfers.filter((p) => p.idgolfer !== parseInt(id));
    setGolfers(newList);

    if (fetchedGolfer && checkPlayers < 1) {
      dispatch5({
        type: "ADDPLAYER",
        player: fetchedGolfer,
      });

      //lock golfer from someone else scoring and record scorer
      const d = new Date();
      const hh = (d.getHours() < 10 ? "0" : "") + d.getHours();
      const mm = (d.getMinutes() < 10 ? "0" : "") + d.getMinutes();

      db.collection("events")
        .doc(eventDate)
        .collection("scores")
        .doc(fetchedGolfer.name)
        .update({
          isLocked: true,
          scorer: user.uid,
          scorerName: user.displayName,
          scorerLocation: location,
          startScoreTime: hh + ":" + mm,
        });
    }
  };

  // const addPlayers = (value) => {
  //   value.map((s) => {
  //     addPlayer(s.idgolfer);
  //   });
  // };

  const onDeletePlayer = (id) => {
    // event.preventDefault();
    // console.log("Delete Pressed", event);
    const deleteGolfer = players.find((s) => s.idgolfer === id);
    dispatch5({
      type: "DELETEPLAYER",
      id: id,
    });

    db.collection("events")
      .doc(eventDate)
      .collection("scores")
      .doc(deleteGolfer.name)
      .update({
        isLocked: false,
        startScoreTime: "",
        scorer: "",
      });
  };

  function Night(props) {
    const sex = props.sex;
    if (sex === "M") {
      return "Mens Night";
    } else {
      return "Ladies Night";
    }
  }

  return (
    <div>
      <div className="event__title">
        {typeof todaysEvent != "undefined" &&
        Object.keys(todaysEvent).length > 0 ? (
          <div className="event__info">
            <h4>Today's Event - {Night(todaysEvent)}</h4>
            <h4> </h4>
            <h4>{todaysEvent.gametype.toLowerCase()} </h4>
            <h4>{todaysEvent.tees.toLowerCase()} Tees </h4>
            <h4>{todaysEvent.fb} </h4>
            {/* <h4>Rating: {todaysEvent.rating}    Slope: {todaysEvent.slope}</h4> */}
            <h4>{todaysEvent.timeentered} </h4>
            <Link to="/menu" className="header__link">
              <div className="header__option">
                <span className="tonights__specials">Tonight's Specials</span>
              </div>
            </Link>
          </div>
        ) : (
          <div className="event__info">
            <h4>No Event Loaded</h4>
          </div>
        )}
      </div>

      {typeof todaysEvent != "undefined" &&
        Object.keys(todaysEvent).length > 0 && (
          <div className="setup__heading">
            <button onClick={() => fetchNewGolfers()}>Get Paid Golfers</button>
            <select onChange={(e) => addPlayer(e.currentTarget.value)}>
              <option key="1111111">Select group members</option>
              {golfers?.map((golfer) => (
                <option key={golfer.idgolfer} value={golfer.idgolfer}>
                  {golfer.last + ", " + golfer.first}
                </option>
              ))}
            </select>
          </div>
        )}

      <div className="player__lineitems">
        {players?.map((player) => (
          <div className="player__entered">
            <Player key={player.id} id={player.id} />

            <button onClick={() => onDeletePlayer(player.id)}>Remove</button>
          </div>
        ))}
      </div>
      <Link to="/wagers">
        <button className="btn__wagers">Group Wagers</button>
      </Link>
      <Link to="/range">
        <button className="btn__wagers">Range Distances</button>
      </Link>
      <Link to="/draw">
        <button className="btn__wagers">Elimination Draw</button>
      </Link>
    </div>
  );
}

export default SetUp;
